module.exports = __webpack_public_path__ + "static/media/ekspozytory_01_A.11bdde36.png";